<template>
  <div class="lectures-calendar-page">
    <LecturesCalendar></LecturesCalendar>
  </div>
</template>

<script>
import LecturesCalendar from "../LecturesCalendar.vue";

export default {
  name: "LecturesPageCalendar",

  components: {
    LecturesCalendar,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  methods: {},
};
</script>
